<template>
  <div v-loading="loading">
    <div class="d-flex align-items-center side-frame-success mb-2">
      <div>
        <div>
          <span style="font-size: 13px; color: #606266">
            {{ formData.amzSkuNo || '' }}
          </span>
          <el-divider direction="vertical" />
          <span style="font-size: 13px; color: #303133">
            {{ formData.invStoreName || '' }}
          </span>
          <el-divider direction="vertical" v-if="formData.v_storeSkuStatus" />
          <el-tag
            v-if="formData.v_storeSkuStatus"
            size="mini"
            :type="
              formData.storeSkuStatus === 'Y'
                ? 'success'
                : formData.storeSkuStatus === 'S' ||
                  formData.storeSkuStatus === 'B' ||
                  formData.storeSkuStatus === 'W'
                ? 'danger'
                : formData.storeSkuStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ formData.v_storeSkuStatus }}
          </el-tag>
          <el-divider direction="vertical" />
          <span style="font-size: 13px; color: #606266">
            {{ formData.amzPeriodTitle || '' }}
          </span>
          <el-divider direction="vertical" />
          <el-button
            type="text"
            style="font-size: 13px;"
            class="py-0"
            @click="openHelp"
          >
            {{ $l('btn_help') || '帮助' }}
          </el-button>
        </div>
      </div>
    </div>
    <el-form ref="form" size="mini" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_goodsName') || '产品名称'">
            <el-input v-model="formData.goodsName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_goodsNameEn') || '英文名称'">
            <el-input v-model="formData.goodsNameEn" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_amzSkuStoreNo') || '店铺SKU'">
            <el-input v-model="formData.amzSkuStoreNo" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_asinCode') || 'ASIN'">
            <el-input v-model="formData.asinCode" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_fnskuCode') || 'FNSKU'">
            <el-input v-model="formData.fnskuCode" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_operateName') || '运营'">
            <el-input v-model="formData.operateName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 class="mt-2 mb-0">{{ $l('form_title_sysData') || '系统数据' }}</h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_soldQtyLast4WkPerDay') || '前30天日销量'"
          >
            <el-input v-model="formData.soldQtyLast4WkPerDay" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_soldQtyLast15Day') || '前15天日销量'"
          >
            <el-input v-model="formData.soldQtyLast15Day" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_soldQtyLast7Day') || '前7天日销量'"
          >
            <el-input v-model="formData.soldQtyLast7Day" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_soldQtyLast3Day') || '前3天日销量'"
          >
            <el-input v-model="formData.soldQtyLast3Day" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_fbaQty') || 'FBA库存'">
            <el-input v-model="formData.fbaQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalInvQty') || '国内库存'">
            <el-input v-model="formData.totalInvQty" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 class="mt-2 mb-0">
        {{ $l('form_title_operateData') || '运营数据' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_halfwayOutageDays') || '中途断货天数'"
            prop="halfwayOutageDays"
          >
            <el-input-number
              v-model="formData.halfwayOutageDays"
              controls-position="right"
              style="width:100%"
              :precision="0"
              :min="0"
              :step="1"
              :disabled="disabled"
              @change="formIsChange = true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_advQtyBeforeRepPerDay') || '实际日销量'"
            prop="advQtyBeforeRepPerDay"
          >
            <el-input-number
              v-model="formData.advQtyBeforeRepPerDay"
              controls-position="right"
              style="width:100%"
              :precision="0"
              :min="0"
              :step="1"
              :disabled="disabled"
              @change="formIsChange = true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_soldQtyAfterRepPerDay') || '到货日预估日销'"
            prop="soldQtyAfterRepPerDay"
          >
            <el-input-number
              v-model="formData.soldQtyAfterRepPerDay"
              controls-position="right"
              style="width:100%"
              :precision="2"
              :min="0"
              :step="0.01"
              :disabled="disabled"
              @change="formIsChange = true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_advQtyAfterRepPerDay') || '到货日活动销量'"
            prop="advQtyAfterRepPerDay"
          >
            <el-input-number
              v-model="formData.advQtyAfterRepPerDay"
              controls-position="right"
              style="width:100%"
              :precision="2"
              :min="0"
              :step="0.01"
              :disabled="disabled"
              @change="formIsChange = true"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 class="mt-2 mb-0">{{ $l('form_title_calcData') || '计算数据' }}</h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item class="link-form">
            <template slot="label">
              <span
                class="form-link"
                @click="showFormula('estmatDaysOfSupply')"
              >
                {{ $l('form_label_estmatDaysOfSupply') || '预计可售天数' }}
              </span>
            </template>
            <el-input v-model="formData.estmatDaysOfSupply" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="link-form">
            <template slot="label">
              <span class="form-link" @click="showFormula('estmatSoldoutDate')">
                {{ $l('form_label_estmatSoldoutDate') || '预计断货日期' }}
              </span>
            </template>
            <el-input v-model="formData.estmatSoldoutDate" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="link-form">
            <template slot="label">
              <span
                class="form-link"
                @click="showFormula('suggestedSubmitQty')"
              >
                {{ $l('form_label_suggestedSubmitQty') || '建议补货数量' }}
              </span>
            </template>
            <el-input v-model="formData.suggestedSubmitQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="link-form">
            <template slot="label">
              <span
                class="form-link"
                @click="showFormula('suggestedReplenishmentDate')"
              >
                {{
                  $l('form_label_suggestedReplenishmentDate') || '建议补货时间'
                }}
              </span>
            </template>
            <el-input v-model="formData.suggestedReplenishmentDate" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 class="mt-2 mb-0">
        {{ $l('form_title_replenishmentData') || '补货数据' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_unitInBox') || '装箱入数'">
            <el-input v-model="formData.unitInBox" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_submitQty') || '实际补货数量'"
            prop="submitQty"
          >
            <el-input-number
              v-model="formData.submitQty"
              ref="submitQtyInput"
              controls-position="right"
              style="width:100%"
              :precision="0"
              :min="0"
              :step="1"
              :disabled="disabled"
              @change="formIsChange = true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_ctnQty') || '整箱'">
            <el-input v-model="ctnQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_tailCtnQty') || '尾箱'">
            <el-input
              v-model="tailCtnQty"
              readonly
              :class="{ 'text-danger': !!tailCtnQty }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="link-form">
            <template slot="label">
              <span class="form-link" @click="showFormula('etaInvDays')">
                {{ $l('form_label_etaInvDays') || '补货后库存天数' }}
              </span>
            </template>
            <el-input v-model="formData.etaInvDays" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_nextReplenishmentDate') || '下次补货时间'"
          >
            <el-date-picker
              v-model="formData.nextReplenishmentDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
              :disabled="disabled"
              @change="formIsChange = true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_label_requestComments') || '备注'">
            <el-input
              v-model="formData.requestComments"
              :disabled="disabled"
              @change="formIsChange = true"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex">
      <div style="font-size: 13px; color: #606266">
        <span>
          Status：
        </span>
        <el-tag
          size="mini"
          v-if="formData.v_approvalStatus"
          :type="
            formData.approvalStatus === 'N' || formData.approvalStatus === 'C'
              ? 'primary'
              : formData.approvalStatus === 'S' ||
                formData.approvalStatus === 'R'
              ? 'warning'
              : formData.approvalStatus === 'Y' ||
                formData.approvalStatus === 'Q'
              ? 'success'
              : formData.approvalStatus === 'D' ||
                formData.approvalStatus === 'B'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_approvalStatus }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span>
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span>
          Approval：{{ formData.approvalByName || '--' }} at
          {{ formData.approvalTime || '--' }}
        </span>
      </div>
    </div>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      append-to-body
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import AutoCacl from './auto-cacl'
import { multiply, divideDown } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading, AutoCacl],
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formIsChange: false,
      rules: {
        halfwayOutageDays: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        advQtyBeforeRepPerDay: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        soldQtyAfterRepPerDay: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        advQtyAfterRepPerDay: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        submitQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('from_placeholder_submitQty')))
                return
              }

              if (this.tailCtnQty > 0) {
                return callback(new Error('补货数量不满整箱'))
              }
              callback()
            },
          },
        ],
        // nextReplenishmentDate: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.tips_select_data') || '请选择...',
        //     trigger: 'change',
        //   },
        // ],
      },
      loading: false,
    }
  },
  computed: {
    ctnQty() {
      const { unitInBox, submitQty } = this.formData
      return divideDown(submitQty, unitInBox, 0)
    },
    tailCtnQty() {
      const { unitInBox, submitQty } = this.formData
      const ctnQty = divideDown(submitQty, unitInBox, 0)
      return submitQty - multiply(ctnQty, unitInBox) > 0 ? 1 : 0
    },
  },
  watch: {
    amzReplenishmentDetailCode: {
      handler(e) {
        if (!e) {
          this.formData = {}
          this.formIsChange = false
          return
        }
        this.getData()
      },
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      // 清空表单校验信息
      this.$refs.form.clearValidate()
      if (!this.amzReplenishmentDetailCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzReplenishmentDetailDetailApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      this.loading = false

      if (!res) return
      const { status } = res
      if (status == 200) {
        this.formData = {}
        this.formIsChange = false
        setTimeout(() => {
          this.formData = { ...res.body }

          // 补货数量自动获取焦点
          this.$refs.submitQtyInput.focus()
        }, 0)
        return
      }
      // API未查询到数据，提示用户然后关闭弹框，刷新列表
      if (status == 203) {
        this.$alert(
          '此产品的补货需求已被删除',
          this.$l('INDEX.tips_question_title') || '提示信息',
          {
            confirmButtonText: '确定',
            callback: () => {
              this.$emit('reload')
              this.formIsChange = false
              this.close()
            },
          }
        )
      }
    },
    async del() {
      if (this.loading) return
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailDelApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.formIsChange = false
      this.$emit('update-success')
      this.close()
    },
    async stopReplenishment() {
      if (this.loading) return
      const confirm = await this.$confirm(
        this.$l('tips_stopReplenishment') || '是否确认该产品不再补货？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailStopReplenishmentApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.formIsChange = false
      this.$emit('update-success')
      this.close()
    },
    /**
     * 保存，成功后刷新
     */
    async save(params = {}) {
      if (this.loading) return
      if (!(await this.submitSave(params))) return
      // 刷新列表后会自动刷新表单
      this.$emit('reload')
      this.close()
    },
    /**
     * 提交保存
     * @params params-除了formData的额外参数，比如isCover-是否强制覆盖数据
     */
    async submitSave(params = {}) {
      if (this.loading) return

      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const { isSaveAndSubmit } = params
      if ('Y' === isSaveAndSubmit) {
        const submitRes = await this.$confirm(
          '是否保存并提交？',
          this.$l('INDEX.tips_question_title') || '提示信息',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => true)
          .catch(() => false)
        if (!submitRes) return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailUpdateApi({ ...this.formData, ...params })
        .catch(() => false)
      this.loadingClose()
      if (!res) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }
      const { status } = res
      // 在提交保存API之前，已有其他用户修改过该记录，是否确认覆盖
      if (status === 203) {
        if (await this.confirmCover()) {
          return await this.submitSave({ isCover: 'Y' })
        }
        return false
      }

      // API未查询到数据，提示用户然后关闭弹框，刷新列表
      if (status == 204) {
        this.$alert(
          this.$l('tips_confirmMsg_delete') || '此产品的补货需求已被删除',
          this.$l('INDEX.tips_question_title') || '提示信息',
          {
            confirmButtonText: '确定',
            callback: () => {
              // 刷新列表
              this.$emit('reload')
              this.formIsChange = false
              this.close()
            },
          }
        )
        return false
      }

      if (status != 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.formIsChange = false

      this.$emit('update-success')
      return true
    },
    /**
     * 是否确认覆盖
     */
    async confirmCover() {
      return await this.$confirm(
        this.$l('tips_confirmCover') ||
          '此产品的补货需求已被其他人修改确认将覆盖信息，确定要覆盖信息吗？',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
    },
    cancel() {
      if (this.disabled || !this.formIsChange) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    getFormData() {
      return this.formData
    },
    clearData() {
      this.formData = {}
    },
    getFormIsChange() {
      return this.formIsChange
    },
    showFormula(key) {
      this.$alert(
        this.$l(`form_caclFormula_${key}`),
        this.$l('INDEX.dialog_title_replenishment_show_caclFormula'),
        { confirmButtonText: '确定', customClass: 'replenishment-showFormula' }
      )
    },
    openHelp() {
      this.$alert(
        `
        <h6>自动计算属性说明</h6>
        <ul>
          <li><strong>预计可售天数</strong>：FBA库存 / 实际日销量</li>
          <li><strong>预计断货日期</strong>：当天日期 + 可售天数 + 中途断货天数</li>
          <li><strong>建议补货数量</strong>：(实际日销量 + 到货日预估日销) / 2 x 30 + 到货日活动销量</li>
          <li><strong>建议补货时间</strong>：预计断货日期 - 90天</li>
          <li><strong>补货后库存天数</strong>：(实际补货数量 - 到货日活动销量) / ((实际日销量 + 到货日预估日销) / 2) + (90 - (预计断货日期 - 当天日期))</li>
        </ul>
      `,
        '帮助',
        {
          dangerouslyUseHTMLString: true,
          customClass: 'replenishment-help-alert',
        }
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  margin: 0;
}

::v-deep {
  .link-form {
    .el-form-item__content {
      pointer-events: none;
      div {
        pointer-events: auto;
      }
    }
    .el-form-item__label {
      .form-link:hover {
        color: #409eff;
        text-decoration: underline;
      }
    }
  }
  .text-danger {
    .el-input__inner {
      color: #dc3545 !important;
    }
  }
}
</style>
<style lang="scss">
.replenishment-showFormula {
  width: 30%;
}

.replenishment-help-alert {
  width: 550px !important;
  ul {
    padding-left: 20px;
  }
}
</style>
